import Api from './api';

const slug = 'v1/faqs';

export default {
  getFaqs(lang) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/`, {
        params: {
          language: lang,
        },
      })
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  createFaq(faq) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/`, faq)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateFaq(faq) {
    return new Promise((resolve, reject) => {
      Api.put(`/${slug}/${faq._id}`, faq)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteFaq(faq) {
    return new Promise((resolve, reject) => {
      Api.delete(`/${slug}/${faq._id}`)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
};
